import { render, staticRenderFns } from "./NpaAnswers.vue?vue&type=template&id=e3ae6dbe&scoped=true"
import script from "./NpaAnswers.vue?vue&type=script&lang=js"
export * from "./NpaAnswers.vue?vue&type=script&lang=js"
import style0 from "./NpaAnswers.vue?vue&type=style&index=0&id=e3ae6dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ae6dbe",
  null
  
)

export default component.exports